import { NimmstaDataSource } from '@nimmsta/ng-commons-lib/data-table';
import { Pageable, Software } from '@nimmsta/ng-commons-lib/models';
import { SFSOptions } from '@nimmsta/ng-commons-lib/data-access';
import { SoftwareService } from '@nimmsta/ng-commons-lib/services/software';
import { Observable } from 'rxjs';

export class SoftwareDatasource extends NimmstaDataSource<Software> {
  constructor(softwareService: SoftwareService, private typeId?: string) {
    super(softwareService);
  }

  override loadData(options?: Partial<SFSOptions>): Observable<Pageable<Software>> {
    if (!this.typeId) {
      return super.loadData(options);
    }
    const filter = `type.id:${this.typeId}-and`;
    if (!options) {
      return super.loadData({ filter: [filter] });
    }
    return super.loadData({ ...options, filter: [...(options.filter ?? []), filter] });
  }
}
